import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { VENTASINGRESOGUIA_LISTA, VENTASINGRESOGUIA_NUEVA } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'

export default function VentasIngresoGuiaPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${VENTASINGRESOGUIA_LISTA}`} component={ListaPage} />
        <Route path={`/${VENTASINGRESOGUIA_NUEVA}/:id`} component={NuevoPage} />
        <Route path={`/${VENTASINGRESOGUIA_NUEVA}`} component={NuevoPage} />
      </Switch>
    </Suspense>
  )
}
